// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"208387fe","112":"5fee9086","140":"5fee9086","676":"208387fe","697":"e7baf376","879":"46629292"}[chunkId] + ".css";
};